import React, { useContext, useState } from 'react';

export interface IAgeContext {
    isAgeVerified: boolean;
    setIsAgeVerified: (isAgeVerified: boolean) => void;
}

const defaultAgeValue: IAgeContext = {
    isAgeVerified: false,
    setIsAgeVerified: () => {},
};

const AgeContext = React.createContext(defaultAgeValue);

export const AgeContextProvider: React.FC<{
    children: React.ReactNode;
}> = ({ children }) => {
    const [isAgeVerified, setIsAgeVerified] = useState(false);
    return (
        <AgeContext.Provider value={{ isAgeVerified, setIsAgeVerified }}>
            {children}
        </AgeContext.Provider>
    );
};

export const useAgeContext = () => {
    const context = useContext(AgeContext);

    if (context === undefined) {
        throw new Error('useAgeContext was used outside of its Provider');
    }

    return context;
};
